import React from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { SEO } from '../../seo/SEO';

/**
 * Guards finance routes. Admin tokens also pass (admins inherit finance scope).
 */
export const FinanceRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="min-h-screen bg-background flex items-center justify-center"
        data-testid="finance-route-loading"
      >
        <SEO title="Finance" noIndex includeRestaurantSchema={false} />
        <Loader2 className="h-8 w-8 animate-spin text-emerald-600" />
      </div>
    );
  }

  if (!user || (!user.is_finance && !user.is_admin)) {
    return <Navigate to="/finance/login" replace />;
  }

  return (
    <>
      <SEO title="Finance" noIndex includeRestaurantSchema={false} />
      {children}
    </>
  );
};

export default FinanceRoute;
